<template>
<div ref="scrollContent" class="heatmap-report content padding_both_sides" @click="onHideSettingOption">
  <div v-if="isExactMatchType">
    <h2 class="title">{{ $t('ab.title') }} ({{ $t('ab.regOpt') }})</h2>
  </div>
  <div class="content__body">
    <!-- loading -->
    <div class="content__loading" v-if="isLoading">
      <ui-loading-circle :applyBackground="true"/>
    </div>
    <template v-else>
      <!-- AB 불가 : 매치타입 -->
      <div v-if="!isExactMatchType" class="box-layout content__match-type">
        <strong>{{ $t('ab.exactOnly.title') }}</strong>
        <figure class="fig-icons">
          <i class="icon icon--return-green-size70"></i>
          <i class="icon icon--warning-red-size30"></i>
        </figure>
        <p class="slogan" v-html="$t('ab.exactOnly.slogan', {matchType: applyData.matchType})"></p>
        <div class="page-info">
          <p class="page-name">{{ applyData.pageName }}</p>
          <p class="page-url">
            <span class="match-type">{{ applyData.matchType | matchType }}</span>
            <span>{{ applyData.url }}</span>
          </p>
        </div>
        <ui-button primary iconName="icon--back-white-size16" :disabled="isShared" @click="onGotoApplyRegister" class="btn__register">
          <span class="btn-text">{{ $t('common.registerPage') }}</span>
        </ui-button>
      </div>

      <template v-else>
        <!-- no list : 등록 유도 -->
        <div class="content__option">
          <div class="option--wrap">
            <div class="option">
              <h4 class="option__title">{{ $t('ab.url') }}</h4>
              <i class="option__image icon illust--ab-url"></i>
              <h5 v-html="$t('ab.option.compareUrl')"></h5>
              <ui-button primary2
                         class="option__btn"
                         size="large"
                         :disabled="isShared"
                         @click="onGoToRegister">
                {{ $t('common.select') }}
              </ui-button>
            </div>
            <div :class="['option', {'disabled': applyData.bLogin}]">
              <h4 class="option__title">
                UX Writing
                <i class="icon icon--ab--beta"></i>
              </h4>
              <i class="option__image icon illust--ab-writing"></i>
              <h5 v-html="$t('ab.option.text.title')"></h5>
              <p v-html="$t('ab.option.text.desc')"></p>
              <ui-button primary2
                         class="option__btn"
                         size="large"
                         :disabled="isShared || applyData.bLogin"
                         @click="onGoToRegisterText">
                {{ $t('common.select') }}
              </ui-button>
              <i class="icon icon--warning-red-size20" v-if="applyData.bLogin">
                <ui-tooltip arrowBottom arrowCenter>
                  <span v-html="$t('ab.option.text.tooltip')"></span>
                </ui-tooltip>
              </i>
              <div class="option__filter" v-if="applyData.bLogin" />
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { getList } from '@/api/abtest'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import UiButton from '@/components/ui/UiButton'
import UiTooltip from '@/components/ui/UiTooltip'

export default {
  name: 'ABOption',
  components: {
    UiLoadingCircle,
    UiButton,
    UiTooltip
  },
  data () {
    return {
      isLoading: false,
      showABOptions: false,
      abPageList: [],
      showBLoginTooltip: true
    }
  },
  computed: {
    ...mapState([
      'applyData',
      'abList'
    ]),
    aid () {
      return this.$route.params.aid
    },
    routeParams () {
      return {
        aid: this.aid
      }
    },
    hasItems () {
      return this.abList && this.abList.length
    },
    isExactMatchType () {
      return this.applyData.matchType === 'exact'
    },
    isShared () {
      return this.applyData.meta.shared
    }
  },
  methods: {
    getABList () {
      this.isLoading = true

      getList(this.applyData._id)
        .then(data => {
          this.abList = data
          this.isLoading = false
        })
        .catch(err => {
          console.error(err)
          this.isLoading = false
        })
    },
    onHideSettingOption () {
      const settingOptionEl = document.querySelectorAll('.col__setting .setting__option--wrap')
      for (const item of settingOptionEl) {
        item.style.display = 'none'
      }
    },
    onGoToRegister () {
      if (this.isShared) return false
      this.$router.push({
        name: 'ab.add',
        params: this.routeParams
      })
    },
    onGoToRegisterText () {
      if (this.isShared) return false
      this.$router.push({
        name: 'ab.add.text',
        params: this.routeParams
      })
    },
    onGotoApplyRegister () {
      if (this.isShared) return false
      this.$router.push({
        name: 'page-add'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.heatmap-report {
  overflow-y: auto;
  padding-bottom: 85px;
  position: relative;

  .title {
    margin-top: 30px;
    font-size: 22px;
    font-weight: bold;
    color: #444444;
  }

  .content__body {
    display: flex;
    flex-direction: column;
    justify-content: center;

    width: 100%;
    height: 100%;

    .content__option {
      .option--wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 30px;

        .option {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;

          box-sizing: border-box;
          width: 380px;
          height: 427px;
          padding: 50px 30px 25px 30px;
          border-radius: 14px;
          box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
          background-color: #fff;

          border: 2px solid #fff;

          &:hover {
            border: 2px solid #ec0047;
          }

          .option__filter {
            position: absolute;
            top: 0;
            left: 0;

            width: 100%;
            height: 100%;
            border-radius: 14px;

            background: rgba(255, 255, 255, 0.6);
          }

          &__image {
            margin-top: 30px;
          }

          h4 {
            font-size: 26px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #444;
          }

          h5 {
            margin-top: 25px;

            font-size: 20px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.3;
            letter-spacing: normal;
            text-align: center;
            word-break: keep-all;
            color: #1199af;
          }

          p {
            margin-top: 11px;
            padding: 0px 30px;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.57;
            letter-spacing: normal;
            text-align: center;
            color: #2f2f2f;
          }

          &__btn {
            position: absolute;
            bottom: 25px;

            &.disabled {
              background-color: rgba(0, 0, 0, 0.36);
              border: 0px;
              opacity: 1;

              /deep/ .text {
                color: white;
              }
            }
          }

          .icon--warning-red-size20 {
            position: absolute;
            bottom: 44px;
            right: 131px;
            z-index: 5;

            .bubble {
              display: none;
              bottom: 30px;
              left: -142px;

              width: 300px;
              justify-content: center;

              /deep/ .text {
                white-space: normal;
              }
            }

            &:hover .bubble {
              display: flex;
            }
          }
        }
      }
    }
  }
}
</style>
